let Test = require('@/mixins/Forms/2019/NRCA_LTI_04_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            functional_test: {
                name: `B. Functional Testing using Illuminance Measurement (NA7.6.3.2, Method 1)`,
                steps: {
                    step_1: {
                        name: `Step 1: Select one location for illuminance measurement. The chosen location must not be in a skylit or primary sidelit area and the illuminance meter must not have a direct view of a window or skylight. If this is not possible, perform the test at a time and location at which daylight illuminance provides less than half of the design illuminance. (NA7.6.3.2, Method 1(a))`,
                        questions: {
                            question_1: {
                                id: `a`,
                                type: 'Float',
                                question: `Enter the design illuminance value in footcandles (fc)`,
                                spaces: []
                            }
                        }
                    },
                    step_2: {
                        name: `Step 2: Full output test (NA7.6.3.2, Method 1(b))`,
                        questions: {
                            question_1: {
                                id: `b`,
                                type: 'Text',
                                text: `Using the manual switches/dimmers, set the lighting system to full output. The lighting in areas with photo controls or occupant/vacancy sensors may be at less than full output or may be off. (NA7.6.3.2, Method 1(b)1)`,
                            },
                            question_2: {
                                id: `c`,
                                type: 'Float',
                                question: `Measure the illuminance at the selected location and enter the value in footcandles (fc). (NA7.6.3.2, Method 1(b)2)`,
                                spaces: []
                            },
                            question_3: {
                                id: `d`,
                                type: 'Text',
                                text: `Simulate a demand response condition using the demand responsive control. (NA7.6.3.2, Method 1(b)3)`,
                            },
                            question_4: {
                                id: `e`,
                                type: 'Float',
                                question: `Measure the illuminance at the selected location with the electric lighting system in the demand response condition and enter the value in footcandles (fc). (NA7.6.3.2, Method 1(b)4)`,
                                spaces: []
                            },
                            question_5: {
                                id: `f`,
                                type: 'Percentage',
                                question: `Calculate the percent reduction in illuminance from the full output condition to the demand response condition and enter the value in %. (Percent reduction = [(line c - line e) / line c] x 100%)`,
                                spaces: []
                            },
                            question_6: {
                                id: `g`,
                                type: 'Float',
                                question: `Enter the area of the controlled space in square feet (ft2)`,
                                spaces: []
                            },
                            question_7: {
                                id: `h`,
                                type: 'Percentage',
                                question: `Calculate the area-weighted average reduction in illuminance from the full output condition to the demand response condition for the building using the given formula and enter the value in %. (NA7.6.3.2, Method 1(b)5)`,
                                answer: 0,
                                merge_cells: true,
                            },
                            question_8: {
                                id: `i`,
                                type: 'BooleanResult',
                                question: `The area-weighted average reduction (line h) is at least 15%. (NA7.6.3.2, Method 1(b)5, Section 110.12(c))`,
                                answer: false,
                                merge_cells: true,
                            },
                            question_9: {
                                id: `j`,
                                type: 'BooleanResult',
                                question: `The combined electric light and daylight illuminance is not reduced to less than 50% of the design illuminance in the tested space. (NA7.6.3.2, Method 1(b)5) ([line e / line a] >= 50%) Enter yes (Y) or no (N).`,
                                spaces: [],
                            },
                        }
                    },
                    step_3: {
                        name: `Step 3: Minimum output test (NA7.6.3.2, Method 1(c))`,
                        questions: {
                            question_1: {
                                id: `k`,
                                type: 'Text',
                                text: `Using the manual switches/dimmers in each space, set the lighting system to minimum output (but not off). The lighting in areas with photo controls or occupant/vacancy sensors may be at more than minimum output or may be off. (NA7.6.3.2, Method 1(c)1)`,
                            },
                            question_2: {
                                id: `l`,
                                type: 'Float',
                                question: `Measure the illuminance at the selected location and enter the value in footcandles (fc). (NA7.6.3.2, Method 1(c)2) `,
                                spaces: []
                            },
                            question_3: {
                                id: `m`,
                                type: 'Text',
                                text: `Simulate a demand response condition using the demand responsive control. (NA7.6.3.2, Method 1(c)3)`,
                            },
                            question_4: {
                                id: `n`,
                                type: 'Float',
                                question: `Measure the illuminance at the selected location with the electric lighting system in the demand response condition and enter the value in footcandles (fc). (NA7.6.3.2, Method 1(c)4)`,
                                spaces: []
                            },
                            question_5: {
                                id: `o`,
                                type: 'BooleanResult',
                                question: `The illuminance in the demand respond condition (line n) is not reduced to below the lesser of: the illuminance in the minimum output condition (line l) or 50% of the design illuminance (line a). (NA7.6.3.2, Method 1(c)5) Enter yes (<b>Y</b>) or no (<b>N</b>).<br><small>Exception: In daylit spaces, the illuminance in the demand response condition (line n) may reduce below the illuminance in the minimum output condition. However, the combined electric light and daylight illuminance in the demand response condition must still be at least 50% of the design illuminance (line a). (NA7.6.3.2, Method 1(c)5 EXCEPTION)</small>`,
                                spaces: []
                            },
                        }
                    },
                },
                result: false,
                comments: '',
                spaces: [],
            },
        }
    },

    mounted() {
        if (this.data == null) {
            this.addSpace();
        }
    },

    methods: {

        functionalTestEvaluation() {

            this.form.functional_test.result = true;

            var steps = this.form.functional_test.steps;

            var s1Questions = steps.step_1.questions;
            var s2Questions = steps.step_2.questions;
            var s3Questions = steps.step_3.questions;

            var row_H_top = 0;
            var row_H_bottom = 0;

            _.each(this.form.functional_test.spaces, (space, index) => {

                // Line F =  [(Line C - Line E) / Line C] x 100%)
                var row_C = s2Questions.question_2.spaces[index].answer;
                var row_E = s2Questions.question_4.spaces[index].answer;
                var row_F = ((row_C - row_E) / row_C);
                s2Questions.question_5.spaces[index].answer = this.isValidNumber(row_F) ? row_F : 0;

                // Line H
                var row_G = s2Questions.question_6.spaces[index].answer;

                row_H_top += (row_F * row_G)
                row_H_bottom += row_G;

                // Line J
                var row_A = s1Questions.question_1.spaces[index].answer;
                var row_J = s2Questions.question_9.spaces[index].answer = (row_E / row_A) >= .5

                // Line O
                var row_L = s3Questions.question_2.spaces[index].answer;
                var row_N = s3Questions.question_4.spaces[index].answer;

                // 50% of Line A
                var _50PercentOfRowB = (.5 * row_A)

                // Changes made by Mario Martinez
                var resultOne = (row_L < _50PercentOfRowB && row_N < row_L);
                var resultTwo = (row_L >= _50PercentOfRowB && row_N < _50PercentOfRowB);
                var resultThree = (row_N <= row_A);
                var resultFour = (row_L > 0);

                var row_O = s3Questions.question_5.spaces[index].answer = (!resultOne && !resultTwo && resultThree && resultFour);

                if (row_J == false || row_O == false) {
                    console.log(2);
                    this.form.functional_test.result = false;
                }
            })

            // Line H
            var result = (row_H_top / row_H_bottom);
            var row_H = s2Questions.question_7.answer = this.isValidNumber(result) ? result : 0;

            // Line I
            var row_I = s2Questions.question_8.answer = (row_H >= .15);

            if (row_I == false) {
                this.form.functional_test.result = false;
            }
        },

        loadFormData() {
            if (!this.data) return;

            _.each(this.data.construction_inspection.questions, (question, i) => {
                this.form.construction_inspection.questions[i].answer = question.answer;
            })

            _.each(this.data.functional_test.spaces, space => {
                this.updateQuestionSpaces(space);
            })

            _.each(this.data.functional_test.steps, (step, i) => {
                _.each(step.questions, (question, j) => {
                    _.each(this.data.functional_test.spaces, (space, k) => {
                        if (!this.isText(this.form.functional_test.steps[i].questions[j])) {
                            if (question.hasOwnProperty('merge_cells')) {
                                this.form.functional_test.steps[i].questions[j].answer = question.answer;
                            } else {
                                this.form.functional_test.steps[i].questions[j].spaces[k].answer = question.spaces[k].answer
                            }
                        }
                    })
                })
            })

            this.form.comments = this.data.comments;
        },

        removeSpace() {
            if (this.canRemoveSpace) {
                var space = this.form.functional_test.spaces[this.form.functional_test.spaces.length - 1];
                Alert.confirmation(`All data with from Space ${space.name} will be removed.<br>Do you want to continue?`).then(response => {
                    this.form.functional_test.spaces.pop();
                    this.removeSpaceFromQuestions();
                }).catch(() => {
                })
            }
        },

        removeSpaceFromQuestions() {
            _.each(this.form.functional_test.steps, step => {
                _.each(step.questions, question => {
                    if (!this.isText(question)) {
                        question.spaces.pop()
                    }
                })
            })
        },

        addSpace() {
            this.updateQuestionSpaces({
                id: (this.form.functional_test.spaces.length + 1),
                name: `#${this.form.functional_test.spaces.length + 1}`
            });
        },

        updateQuestionSpaces(space) {
            this.form.functional_test.spaces.push(space);
            _.each(this.form.functional_test.steps, step => {
                _.each(step.questions, question => {
                    if (question.hasOwnProperty('merge_cells')) {
                        question.answer = this.getDefaultValueForDinamicQuestion(question);
                    } else if (question.type != 'Text') {
                        question.spaces.push({
                            id: space.id,
                            name: space.name,
                            answer: this.getDefaultValueForDinamicQuestion(question),
                        });
                    }
                })
            })
        },

    },

    computed: {

        rowColspan() {
            return this.form.functional_test.spaces.length;
        },

        canRemoveSpace() {
            return this.testIsReady ? (this.form.functional_test.spaces.length > 1) : false;
        },
    }

}
